import ProductDb from '../../data/product-idb';
import {createHomeDetail} from '../template/theme';

const HomeDetail = {
  async render() {
    return `    
          <h1 class="kafe__label">Kafe List</h1>
          <div id="restaurants"></div>
        `;
  },
  async afterRender() {
    try {
      const restaurantContainer = document.querySelector('#restaurants');
      restaurantContainer.classList.add('hidden');
      // Get all restaurant
      const list = await ProductDb.p_list();
      const restaurantList = Object.values(list.restaurants);
      restaurantContainer.innerHTML = restaurantList.length ? restaurantList.map(createHomeDetail).join('') : '<p>No Data.</p>';
      restaurantContainer.classList.remove('hidden');
    } catch (error) {
      const restaurantContainer = document.querySelector('#restaurants');
      restaurantContainer.innerHTML = '<p>Failed to load restaurant data.</p>';
    }
  },

};

export default HomeDetail;
